import { TextField } from "@mui/material";
import PropTypes from "prop-types";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/styles";
RHFTextField.propTypes = {
  name: PropTypes.string,
};

export default function RHFTextField({
  name,
  sx,
  label,
  placeholder,
  ...other
}) {
  const { control } = useFormContext();
const theme = useTheme();

  const isDarkMode = theme.palette.mode === "dark";
  const autofillBg = isDarkMode ? "#171717" : "#ffffff";
  const { t } = useTranslation();
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          fullWidth
          error={!!error}
          helperText={t(error?.message)}
          label={t(label)}
          placeholder={t(placeholder)}
          sx={{
            "& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus, & input:-webkit-autofill:active": {
              WebkitBoxShadow: `0 0 0 1000px ${autofillBg} inset !important`,
            },
            ...sx, 
          }}
          {...other}
        />
      )}
    />
  );
}
